/**
 * Normalize calculator area/length field values.
 * Rejects negatives while allowing empty input and decimal typing.
 */
export const sanitizeMeasurementInput = (value) => {
  if (value == null) return ""

  const nextValue = String(value)
  if (nextValue === "") return ""

  if (nextValue.startsWith("-") || Number(nextValue) < 0) return "0"

  return nextValue
}
